document.addEventListener("DOMContentLoaded", function () {

  // 👇 GLOBAL CAPTURE-PHASE GUARD - runs before ALL other click handlers everywhere
  document.addEventListener('click', function(event) {
    const btn = event.target.closest('[data-variant-id]');
    if (btn) {
      // If custom-code.js guard is already processing this button, stop everything else
      if ($(btn).data('adding-to-cart')) {
        event.stopImmediatePropagation();
        return;
      }
    }
  }, true); // true = capture phase, fires BEFORE bubbling handlers

  // Collection page specific add to cart handling
  if (window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/products/')) {

    const handleAddToCart = function (event) {
      const addToCartBtn = event.target.closest(".productitem--action-atc, [data-variant-id]");

      // 👇 FIXED GUARD - skip ALL buttons that have data-variant-id
      // because custom-code.js already handles those exclusively
      if (addToCartBtn && addToCartBtn.hasAttribute("data-variant-id")) return;

      if (addToCartBtn && !addToCartBtn.classList.contains('go-to-cart-class')) {
        event.preventDefault();
        event.stopPropagation();

        const originalText = addToCartBtn.innerHTML;
        addToCartBtn.innerHTML = 'Adding...';

        const form = addToCartBtn.closest("form[action='/cart/add']");
        if (!form) {
          resetButtonState(addToCartBtn, originalText);
          return;
        }

        const formData = new FormData(form);
        formData.set('quantity', '1');

        fetch("/cart/add.js?_bypassGokwik=1", {
          method: "POST",
          body: formData
        })
          .then(response => {
            if (!response.ok) throw new Error("Failed to add to cart");
            return response.json();
          })
          .then(data => {
            console.log("Product added to cart:", data);
            if (addToCartBtn.getAttribute('data-variant-id')) {
              addToCartBtn.classList.add('go-to-cart-class');
              addToCartBtn.setAttribute('onclick', "var myLink = document.getElementById('myLink'); if(myLink) myLink.click();");
              addToCartBtn.setAttribute('type', 'button');
              if (addToCartBtn.tagName.toLowerCase() === 'a') {
                addToCartBtn.setAttribute('href', 'javascript:void(0)');
              }
              addToCartBtn.innerHTML = `Go to cart
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <g id="Complete">
                      <g id="arrow-right">
                        <g>
                          <polyline data-name="Right" fill="none" id="Right-2" points="16.4 7 21.5 12 16.4 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></polyline>
                          <line fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" x1="2.5" x2="19.2" y1="12" y2="12"></line>
                        </g>
                      </g>
                    </g>
                  </svg>`;
            } else {
              resetButtonState(addToCartBtn, originalText);
            }
            window.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(error => {
            console.error("Add to cart failed:", error);
            resetButtonState(addToCartBtn, originalText);
          });
      }
    };

    function resetButtonState(button, originalHTML) {
      button.innerHTML = originalHTML;
    }

    document.addEventListener('click', handleAddToCart);
  }

  // Product page add to cart handling
  if (window.location.pathname.includes('/products/')) {
    const addToCartBtn = document.querySelector("#AddToCart");
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", function (event) {
        if (addToCartBtn.classList.contains('go-to-cart-class')) return;
        event.preventDefault();
        const form = addToCartBtn.closest("form[action='/cart/add']");
        if (!form) return;

        const originalText = addToCartBtn.innerHTML;
        addToCartBtn.style.opacity = '0.7';

        const formData = new FormData(form);
        fetch("/cart/add.js?_bypassGokwik=1", {
          method: "POST",
          body: formData
        })
          .then(response => {
            if (!response.ok) throw new Error("Failed to add to cart");
            return response.json();
          })
          .then(data => {
            console.log("Product added to cart:", data);

            const go_to_cart_svg = `Go to Cart <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"> <g id="Complete"><g id="arrow-right">   <g>   <polyline data-name="Right" fill="none" id="Right-2" points="16.4 7 21.5 12 16.4 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></polyline> <line fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" x1="2.5" x2="19.2" y1="12" y2="12"></line>  </g>   </g> </g>  </svg>`;

            const btn1 = document.querySelector('#AddToCart');
            if (btn1) {
              const text1 = btn1.querySelector('.atc-button--text');
              if (text1) text1.innerHTML = go_to_cart_svg;
              btn1.style.backgroundColor = '#2eb4ac';
              btn1.style.color = 'white';
              btn1.style.opacity = '1';
              btn1.style.pointerEvents = 'auto';
              btn1.classList.add('go-to-cart-class');
              btn1.setAttribute('onclick', "var myLink = document.getElementById('myLink'); if(myLink) myLink.click(); else window.location.href='/cart';");
              btn1.setAttribute('type', 'button');
            }

            const btn2 = document.querySelector('#AddToCart_secondary');
            if (btn2) {
              const text2 = btn2.querySelector('.atc-button--text');
              if (text2) text2.innerHTML = go_to_cart_svg;
              btn2.style.backgroundColor = '#2eb4ac';
              btn2.style.color = 'white';
              btn2.style.opacity = '1';
              btn2.style.pointerEvents = 'auto';
            }

            window.dispatchEvent(new CustomEvent('cart:item-added', {
              detail: { product: data }
            }));

            if (window.cartStateManager) {
              setTimeout(() => {
                window.cartStateManager.refresh();
              }, 300);
            }
          })
          .catch(error => {
            console.error("Add to cart failed:", error);
            addToCartBtn.innerHTML = originalText;
            addToCartBtn.style.opacity = '';
            addToCartBtn.style.pointerEvents = '';
          });
      });
    }
  }
});

// Simple quantity management
document.addEventListener("DOMContentLoaded", function () {
  const quantityInputs = document.querySelectorAll('.quantity-selector__input, .quantity-input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function () {
      if (parseInt(this.value) < 1) {
        this.value = 1;
      }
    });
  });
});